import React, { FunctionComponent, useState } from 'react'
import Image from '@elements/Image'
import { motion, AnimatePresence } from 'framer-motion'

type Props = {
  name: string
  logo: string
}

const SkillBar: FunctionComponent<Props> = ({ name, logo }) => {
  const [isHovered, setIsHovered] = useState(false)

  return (
    <div 
      className="relative flex items-center justify-center p-4 bg-white dark:bg-black/20 rounded-xl border border-black/5 dark:border-white/5 shadow-sm transition-all duration-300 hover:shadow-md hover:-translate-y-1 hover:bg-white/80 dark:hover:bg-white/5 aspect-square"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className="relative w-10 h-10 transition-transform duration-300 group-hover:scale-110">
         <Image src={logo} width="2.5rem" height="2.5rem" alt={name} className="object-contain" />
      </div>
      
      <AnimatePresence>
        {isHovered && (
          <motion.div
            initial={{ opacity: 0, y: 5, scale: 0.9 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 5, scale: 0.9 }}
            transition={{ duration: 0.2, type: "spring", stiffness: 300, damping: 20 }}
            className="absolute -bottom-4 left-1/2 -translate-x-1/2 z-30 px-3 py-1.5 bg-white/90 dark:bg-black/80 backdrop-blur-md text-[var(--foreground)] text-xs font-semibold rounded-lg shadow-[0_4px_20px_-2px_rgba(0,0,0,0.1)] border border-white/20 dark:border-white/10 whitespace-nowrap pointer-events-none z-[100]"
          >
            {name}
            {/* Glossy highlight effect */}
            <div className="absolute inset-0 rounded-lg ring-1 ring-inset ring-white/20 dark:ring-white/10" />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  )
}

export default SkillBar
